import { deserialise } from 'kitsu-core';
import { leagueFetch } from '@leagueplatform/league-fetch';
import { GET_USER_REWARDS_ACCOUNTS } from '../constants/request-path.constants';
import { GetUserRewardsAccountsResponse } from '../types/response.types';

export const getUserRewardsAccounts = async (
  units?: string[],
): Promise<GetUserRewardsAccountsResponse> => {
  let url = GET_USER_REWARDS_ACCOUNTS;

  // Add filter[unit] query parameters if units are provided
  if (units && units.length > 0) {
    const params = new URLSearchParams();

    params.append('filter[unit]', units.toString());

    url = `${GET_USER_REWARDS_ACCOUNTS}?${params.toString()}`;
  }

  const response = await leagueFetch(url);

  // returns status 405 when reward accounts / user reward accounts are not configured for the user / tenant
  if (!response.ok && response.status !== 405) {
    throw new Error(`error getting user reward accounts: ${response.status}`);
  }
  const responseJson = await response.json();
  return deserialise(responseJson);
};
